<template>
    <v-fade-transition>
        <v-container>
            {{message}}
        </v-container>
    </v-fade-transition>
</template>

<script>
    import { mapActions, mapGetters } from "vuex"
    export default {
        name: 'fromGangnam',
        data() {
            return {
                message: null
            }
        },
        computed: {
			...mapGetters([
                'getSidInfo'
            ]),
        },
        methods: {
			...mapActions([
                'authBySid'
            ]),
        },
        async mounted() {
            const res = await this.authBySid('xURbGH5bLbkE9JfQ2zHsLxzYyQveQ2Hlgws2G2pW1jwEJkTW1xRaG26bwdsnzbgL%2B9ssNO224e1mZEBZmaA%2FkAqPjirYMOUrRYlG9WttubAgNoKl7F09EFnKLdmtmGuuTEhVSk2sF%2F7eX5AtQCzJKc6FRLHlXdtynQeW%2FDSu2tfrliL8%2FoTJeRlBrU39vqBUofGWy%2FNeTHSCuD0ij0bAIw%3D%3D')

            if(Number(res.data.code) === 200) {
                this.$router.replace('/userTermsWOCode')
            } else {
                this.message = '잘못된 접근입니다. ' + res.data.code
            }
        }
    }
</script>

<style scoped lang="scss">
</style>
